import {useQuery} from 'react-query';
import getStoreInputGroups, {
  IGetStoreInputGroupsParams,
} from './getStoreInputGroups';

interface IUseGetStoreInputGroupsProps extends IGetStoreInputGroupsParams {
  enabled?: boolean;
}

const useGetStoreInputGroups = ({
  storeGuid,
  enabled = true,
  only_lendtech,
  status,
}: IUseGetStoreInputGroupsProps) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['get-store-input-groups', storeGuid],
    queryFn: () => getStoreInputGroups({storeGuid, only_lendtech, status}),
    enabled: Boolean(storeGuid) && enabled,
  });

  return {data, isLoading, refetch};
};

export default useGetStoreInputGroups;
